// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse {
    static getAttributeTypeMap() {
        return PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse.attributeTypeMap;
    }
}
PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse.discriminator = undefined;
PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse.additionalProperties = false;
PatientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2ProcessingResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=patientEnrollmentControllerEnrollmentWithEmailSignaturePdfRequestResponse.js.map